"use client";

import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";
import { DataTreeNode } from "./data-tree-node";

interface DebugViewProps {
  data: unknown;
  className?: string;
}

export function DebugView({ data, className }: DebugViewProps) {
  const { t } = useTypedTranslation();

  if (data === null || data === undefined) {
    return (
      <div className={cn("overflow-auto p-4 font-mono text-xs", className)}>
        <div className="text-muted-foreground">
          {t("shareablePreviewNoValue")}
        </div>
      </div>
    );
  }

  const isArray = Array.isArray(data);
  const entries: [string, unknown][] = isArray
    ? (data as unknown[]).map((v, i) => [String(i), v] as [string, unknown])
    : typeof data === "object"
      ? Object.entries(data as Record<string, unknown>)
      : [];

  return (
    <div
      className={cn(
        "overflow-auto p-4 font-mono text-xs bg-gradient-to-br rounded-lg border from-muted/40 to-muted/20 border-border/30",
        className
      )}
    >
      <div className="space-y-1">
        {entries.map(([key, value]) => (
          <DataTreeNode key={key} nodeKey={key} value={value} level={0} />
        ))}
      </div>
    </div>
  );
}
